import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getConfig from '../../../helpers/config';
import { getPrepareHeaders } from '../get-prepare-headers';
import { IdEntity } from '../../../interfaces/common-interfaces';
import {
  EmertimNumri,
  FVCards,
  StatistikaNderVite,
  Top10Trajnues,
} from '../../../interfaces/dashboard';

const {
  test: { baseUrl },
} = getConfig();

export const dashboardFVApi = createApi({
  reducerPath: 'dashboardFVStats',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: getPrepareHeaders,
  }),
  tagTypes: ['DashboardFVStats'],
  endpoints: builder => ({
    getFvKartat: builder.query<FVCards, IdEntity>({
      query: ({ id }) => `statistika-fv/kartat/${id}`,
    }),

    getTrajnimeNderVite: builder.query<StatistikaNderVite[], void>({
      query: () => ({
        url: '/statistika-fv/trajnime-nder-vite',
      }),
    }),

    getPjesemarresNderVite: builder.query<StatistikaNderVite[], void>({
      query: () => ({
        url: '/statistika-fv/pjesemarres-nder-vite',
      }),
    }),

    getMesatarjaNderVite: builder.query<StatistikaNderVite[], void>({
      query: () => ({
        url: '/statistika-fv/mesatarja-nder-vite',
      }),
    }),

    getTop10Trajnues: builder.query<Top10Trajnues[], IdEntity>({
      query: ({ id }) => ({
        url: `/statistika-fv/top10-trajnues/${id}`,
      }),
    }),

    getPjesemarresSipasInstitucionit: builder.query<EmertimNumri[], IdEntity>({
      query: ({ id }) => ({
        url: `/statistika-fv/pjesemarres-sipas_institucionit/${id}`,
      }),
    }),

    getPjesemarresSipasTrajnimeve: builder.query<EmertimNumri[], IdEntity>({
      query: ({ id }) => ({
        url: `/statistika-fv/pjesemarres-sipas-trajnimeve/${id}`,
      }),
    }),

    getPjesemarresSipasKategorise: builder.query<EmertimNumri[], IdEntity>({
      query: ({ id }) => ({
        url: `/statistika-fv/pjesemarres-sipas-kategorise/${id}`,
      }),
    }),

    getPjesemarresSipasFunksionit: builder.query<EmertimNumri[], IdEntity>({
      query: ({ id }) => ({
        url: `/statistika-fv/pjesemarres-sipas-funksionit/${id}`,
      }),
    }),

    getPjesemarresSipasGjinise: builder.query<EmertimNumri[], IdEntity>({
      query: ({ id }) => ({
        url: `/statistika-fv/pjesemarres-sipas-gjinise/${id}`,
      }),
    }),
  }),
});

export const {
  useGetFvKartatQuery,
  useGetTrajnimeNderViteQuery,
  useGetPjesemarresNderViteQuery,
  useGetMesatarjaNderViteQuery,
  useGetTop10TrajnuesQuery,
  useGetPjesemarresSipasInstitucionitQuery,
  useGetPjesemarresSipasTrajnimeveQuery,
  useGetPjesemarresSipasKategoriseQuery,
  useGetPjesemarresSipasFunksionitQuery,
  useGetPjesemarresSipasGjiniseQuery,
} = dashboardFVApi;
